<template>
  <div>
    <BaseTitle :title="$t('menu.assignment_score')" :yearPeriode="titleData" />
    <div>
      <v-row>
        <v-col cols="12" md="8" class="py-0 mb-2">
          <div class="move-list">
            <div class="move-list-title pa-5">
              <div class="d-flex justify-space-between align-center">
                <span
                  >{{ studentData.assignmentTitle }}<br />
                  {{ $t('content.due_date') }} : {{ studentData.dueDate }} <span v-if="!studentData.dueDate">-</span> <br />
                  {{ $t('content.name_teacher') }} : {{ studentData.teacherName }} <span v-if="!studentData.teacherName">-</span> </span
                ><span>
                  <span class="mr-8 pointer" @click="studentFrom">{{ equal }}</span>
                  {{ index + 1 }} / {{ listStudentFile.length }} {{ $t('content.student') }}
                  <span class="ml-8 pointer" @click="studentTo">></span>
                </span>
              </div>
            </div>
            <div class="move-list-content">
              <ul>
                <li>
                  <iframe v-if="extension === 'pdf'" :src="studentData.file.fileUrl" class="viewer-content" />
                  <img
                    v-if="extension === 'png' || extension === 'jpg' || extension === 'jpeg'"
                    :src="studentData.file.fileUrl"
                    style="
                      width : 100%;
                      height : 800px;
                      flex: 1;
                    "
                  />
                  <iframe
                    v-if="
                      extension === 'doc' ||
                        extension === 'docx' ||
                        extension === 'xlsx' ||
                        extension === 'xls' ||
                        extension === 'ppt' ||
                        extension === 'pptx'
                    "
                    :src="`https://view.officeapps.live.com/op/embed.aspx?src=${studentData.file.fileUrl}`"
                    class="viewer-content"
                  />
                  <audio
                    v-if="extension === 'mp3'"
                    controls
                    style="
                      width : 100%;
                      flex: 1;
                    "
                    class="d-flex align-center justify-center text-center"
                    :src="studentData.file.fileUrl"
                  >
                    <source :src="studentData.file.fileUrl" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                  <video
                    v-if="extension === 'mp4'"
                    controls
                    class="d-flex align-center justify-center text-center v"
                    style="
                      width : 100%;
                      flex: 1;
                    "
                    :src="studentData.file.fileUrl"
                  >
                    <source :src="studentData.file.fileUrl" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <div class="move-list">
            <div class="move-list-title d-flex justify-center pa-7">
              <svg-icon icon="ic-profile" width="21px" height="22px" class="mr-2" /> <span class="mt-1">{{ studentData.fullName }} </span>
              <div class="text-center ml-3">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <span dark v-bind="attrs" v-on="on">
                      <svg-icon icon="ic-moreaction-white" class="mt-1" />
                    </span>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in listStudentFile" :key="index">
                      <v-list-item-title class="text-dropdown" @click="updateKey(index)">{{ item.fullName }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div class="move-list-content">
              <ul>
                <span class="text-right"> {{ $t('content.submitted') }}: </span>
                <li style="color : #F7B500">{{ studentData.submittedDate }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.assignment_type') }} : </span>
                <li>{{ $t('content.assignment_item.upload_files') }}</li>
              </ul>
              <ul>
                <span class="text-right"> {{ $t('content.submitted_files') }}: </span>
                <li style="color : #F7B500">
                  <a :href="linkDownload">{{ fileName }}.{{ extension }}</a>
                </li>
              </ul>

              <ul>
                <span class="text-right"> {{ $t('content.score') }}: </span>
                <li>
                  <div class="d-flex flex-row ">
                    <div style="width: 50px">
                      <v-text-field
                        type="number"
                        min="0"
                        v-model="studentData.point"
                        @input="maximum($event)"
                        v-number
                        :label="$t('content.score')"
                      />
                    </div>
                    <div class="ml-3 mt-6">
                      {{ $t('form.from') }}
                      {{ totalPoint }}
                    </div>
                  </div>
                  <!-- <div style="width: 60px">
                    <v-text-field type="number" min="0" v-model="studentData.point" @input="maximum($event)" v-number :label="$t('content.score')" />
                  </div>

                  {{ $t('form.from') }}
                  {{ totalPoint }} -->
                </li>
              </ul>

              <ul>
                <span class="text-right"> {{ $t('content.comments') }}: </span>
                <li>
                  <text-editor v-model="studentData.comment" />
                </li>
              </ul>
              <hr />

              <div class="d-flex justify-end align-center">
                <v-btn color="primary" class="btn-primary-custom mr-3 mt-10" outlined @click="back">{{ $t('back') }}</v-btn>
                <v-btn color="primary" class="btn-primary-custom mt-10" type="submit" @click="submit" :loading="loading">
                  {{ $t('submit') }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
        <!-- Dialog Success -->
        <v-dialog v-model="dialogPopUp" persistent max-width="800">
          <v-card>
            <div class="d-flex justify-center">
              <svg-icon icon="img-success" class="succ-featured pa-10" width="860" height="300" />
            </div>
            <v-card-title class="headline d-flex justify-center assignment-content">{{ $t('success.add_assignment_score_file') }} </v-card-title>
            <v-card-text class="d-flex justify-center">{{ $t('success.add_assignment_content_score_file') }} </v-card-text>
            <v-card-text class="d-flex justify-center">
              <v-btn color="primary" class="btn-primary-custom" @click="dialogPopUp = false">
                {{ $t('close') }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import TextEditor from '@/components/base/TextEditor.vue';

export default {
  name: 'TeacherAssignmentScoreFile',
  components: {
    BaseTitle,
    TextEditor
  },
  computed: {
    ...mapGetters({
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    linkDownload() {
      return `${this.baseUrl}/api/file/download?key=${this.studentData?.file?.key}`;
    },
    extension() {
      return this.studentData?.file?.extension;
    },
    fileName() {
      return this.studentData?.file?.fileName;
    },
    totalPoint() {
      return this.studentData?.file?.totalPoint;
    },
    equal() {
      return '<';
    }
  },
  data: () => ({
    dialogPopUp: false,
    baseUrl: process.env.VUE_APP_BASE_URL,
    dataClass: '',
    loading: false,
    listStudentFile: [],
    studentData: {},
    index: 0,
    form: {
      studentId: '',
      score: '',
      comment: ''
    },
    titleData: ''
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    maximum(e) {
      if (Number(e) > Number(this.studentData.file.totalPoint)) {
        this.$nextTick(() => {
          this.studentData.point = this.studentData.file.totalPoint;
        });
      }
    },
    studentFrom() {
      if (this.index > 0) {
        this.index = this.index - 1;
        this.studentData = this.listStudentFile?.[this.index];
      }
    },
    studentTo() {
      if (this.listStudentFile.length - 1 > this.index) {
        this.index = this.index + 1;
        this.studentData = this.listStudentFile?.[this.index];
      }
    },
    getData() {
      var assignmentId = this.$route.params.assignmentId;
      this.$store
        .dispatch('Assignment/fetchListFile', { assignmentId })
        .then(res => {
          let temp;
          const mappingData = res.map(value => {
            temp = value.comment;
            delete value.comment;
            return {
              comment: temp ? temp : '',
              ...value
            };
          });
          if (this.index == 0) {
            this.studentData = mappingData?.[0];
          } else {
            this.studentData = mappingData?.[this.index];
          }
          // this.studentData = res?.[0];
          this.listStudentFile = mappingData;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    updateKey(key) {
      this.studentData = null;
      this.studentData = this.listStudentFile?.[key];
      this.index = key;
    },
    submit() {
      var assignmentId = this.$route.params.assignmentId;
      this.form.studentId = this.studentData.studentId;
      this.form.score = this.studentData.point;
      this.form.comment = this.studentData.comment;
      this.loading = true;
      this.$store
        .dispatch(`Assignment/saveScoringFile`, { ...this.form, assignmentId })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success' });
          this.studentTo();
          this.getData();
          // this.dialogPopUp = true;
          // this.getData();
          // this.$router.push({ name: 'TeacherGrupAssignmentSuccessScoreFile' });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    back() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentDetail' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionDetail' });
      }
    }
  },
  created() {
    this.getData();
    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.move-list {
  height: 100%;

  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    background: #fff;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.text-dropdown {
  cursor: pointer;
}

.text-right {
  display: flex;
  justify-content: space-between;
  margin-left: 15px;
  margin-top: 10px;
  align-items: center;
  font-weight: bold;
}
.viewer {
  @extend %overlay;
  color: #fff;
  display: flex;
  flex-direction: column;
  z-index: 200;

  &-bar {
    display: flex;
    align-items: center;
    padding: 20px;
    background: rgba($color: #000000, $alpha: 0.5);
  }

  &-content {
    height: 800px;
    flex-basis: 100%;
    border: none;
  }
}

.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }
}
</style>
